/**
 * simple stuff to make numbers pretty
 * formats stuff to be like this: €XX.XXX,XX
 */
export const formatCurrency = (number, currencySign = "€") =>
  currencySign +
  number
    .toFixed(2)
    .replace(".", ",")
    .replace(/\d(?=(\d{3})+\.)/g, "$&.");

/**
 * does the same thing as the format currency but adds the number signal before (for them sweet sweet differentials)
 */
export const formatCurrencyDiff = (number, currencySign = "€") =>
  (number < 0 ? "- " : "+ ") + formatCurrency(Math.abs(number), currencySign);

/**
 * this is a simple "store" reducer
 */
export const packReducer = (state, action) => {
  let newState = {...state};
  switch (action.type) {
    case "SET": {
      newState[action.payload.type] = action.payload.value;
      break;
    }
  }
  return newState;
};

/**
 * click events attribute builder
 * this is particularly useful to build the stuff GA needs to apply events
 * since it's "recipe" based.. made a function out of it
 *
 * packIdx = package's index: first package - 0 | second package - 1 | etc...
 * packEventRegion - package specific prop (defined in the JSON) path is event.region
 * packTitle - package's title
 * lineIdx - line's index, "Aderir" button - 0 | offers - 1 | tv - 2 | etc...
 * packEventLink - package specific prop (defined in the JSON) path is event.link
 * title - text on the thing that gets clicked
 * weightIdx - (optional) this is used when you click weighted options (e.g. the second option on TV would be "1" and the third would be "2" etc... )
 */
export const eventAttrBuilder = (
  packIdx,
  packEventRegion,
  packTitle,
  lineIdx,
  packEventLink,
  title,
  weightIdx
) => ({
  "data-eventregion":
    packEventRegion +
    "_" +
    lineIdx +
    "." +
    packIdx +
    (weightIdx ? "." + weightIdx : ""),
  "data-eventclick": title + "_" + packTitle,
  "data-eventtitle": title,
  "data-eventlink": packEventLink,
});

/**
 * a constant
 * it specifies the order of the weights
 * it must contain every weight possible (on listing)
 * if you need more weights specify it here
 * do not remove!
 * may break existing stuff if a key is missing!
 * the keys here map to the css class to render the icon
 */
export const weightOrder = [
  "tv",
  "net",
  "mobile",
  "netmobilespeed",
  "card",
  "phone",
  "data",
  "voice",
  "internationalvoice",
  "netmobile",
  "apps",
];

/**
 * another constant
 * this is to specify weights that mess around with the pack/price/discount
 * but dont actually get rendered alongside the remaining weights
 * at the moment it is only offers
 * but who knows
 * one day it might also have chairs....
 */
export const alsoImportantWeights = ["offers"];
